import Observer from 'fontfaceobserver';
import css from './fonts.scss';

const NORMAL = 400;
const BOLD = 700;
const MEDIUM = 500;
const fontWeights = [NORMAL, MEDIUM, BOLD];
/*
    fontFamily: name of the font to use in CSS ('Noto Sans', i.e.)
    googleFontFamily: name of the font to build up the URL ('Noto+Sans', i.e.)
*/
const lrtFontConfig = {
    fontFamily: 'Roboto',
    googleFontFamily: 'Roboto'
};
const rtlFontConfig = {
    fontFamily: 'Tajawal',
    googleFontFamily: 'Tajawal'
};

function getFontUrl(fontFamily) {
    return `https://fonts.googleapis.com/css2?family=${fontFamily}:wght@${fontWeights.join(';')}&display=swap`;
}

export default {
    load: (dir, bIsCustom) => {
        const fontConfig = dir === 'ltr'
            ? lrtFontConfig
            : rtlFontConfig;

        if (!bIsCustom) {
            preloadFont(fontConfig.googleFontFamily);
            download(fontConfig.googleFontFamily);
            apply(fontConfig.fontFamily, `font-ready-${dir}`);
        }
    }
};

function preloadFont(fontFamily) {
    const head = document.getElementsByTagName('head')[0];
    const preloadLink = document.createElement('link');

    preloadLink.rel = 'preload';
    preloadLink.as = 'font';
    preloadLink.href = getFontUrl(fontFamily);
    preloadLink.type = 'text/css';
    preloadLink.crossOrigin = 'anonymous';
    head.appendChild(preloadLink);
}

function download(fontFamily) {
    const head = document.getElementsByTagName('head')[0];
    const link = document.createElement('link');

    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = getFontUrl(fontFamily);
    link.crossorigin = 'anonymous';
    link.media = 'all';
    head.appendChild(link);
}

function apply(fontFamily, cssFontReadyClass) {
    const fontsObserver = fontWeights.map(weight => {
        return new Observer(fontFamily, {
            weight
        }).load();
    });

    Promise.all(fontsObserver)
        .then(() => {
            document.documentElement.classList.add(css[cssFontReadyClass]);
        });
}
